<template>
	<div class="ProductTraceabilityBox">
		<div class="ProductTraceability">
			<div class="FromComm">
				<FromComm :FromArr="FromArr"></FromComm>
				<div class="btns">
					<el-button @click="reset">
						重置
					</el-button>
					<el-button @click="SelectClick">
						查询
					</el-button>
				</div>
			</div>
			<h1>追溯结果</h1>
			<div class="TableWidth">
				<!--  -->
				<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="Export"
					:src="require('@/assets/icon/daoc.png')">
				</Commonbtn>
				<Commontable @onRowClick="onRowClick" :loadingTable="ProductLoadingTable" colnum=7
					:tableData="tableData" :headerData="headerData" height="100%">
				</Commontable>
				<div class="pagination">
					<Pagination type="allColor" @handleCurrentChange="handleCurrentChange"
						@handleSizeChange="handleSizeChange" :total="total" :pageSize="pageSize"></Pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import FromComm from '../components/fromComponents/Commfrom/from-comm.vue'
	import Commontable from '@/components/common-table.vue'
	import Pagination from '@/components/pagination.vue'
	import FromArr from './FromData/FromArr'
	import headerData from './headerData/headerData'
	import Commonbtn from '@/components/common-btn.vue'
	import utils from '@/common/utils'
	import {
		ProductTraceability
	} from '@/api/channel'
	import {
		InventoryClassList
	} from '@/api/home'
	
	import {
		exportProductTraceability,
		GetFirstOrganization
	} from '@/api/newsapi'
	export default {
		components: {
			FromComm,
			Commontable,
			Pagination,
			Commonbtn
		},
		data() {
			return {
				FromArr: [],
				rowData: [],
				headerData: [],
				tableData: [],
				ProductLoadingTable: false,
				total: 0,
				pageSize: 20,
				pageIndex: 1
			}
		},
		mounted() {
			this.FromArr = JSON.parse(JSON.stringify(FromArr))
			this.headerData = JSON.parse(JSON.stringify(headerData))
			this.ProductTraceability()
			this.initFirstOrgOptions()
			this.initInvClassOptions()
		},
		methods: {
			async initInvClassOptions() {
				let { code, data } = await InventoryClassList({});
				if (code == 0 && data && data.data) {
					this.FromArr[5].options = data.data.map(item => ({
						key: item.InvClass,
						value: item.InvClassName
					}));
				}
			},
			initFirstOrgOptions() {
				GetFirstOrganization().then(res => {
					if (res.code === 0) {
						this.FromArr[3].options = res.data.map(item => ({
							key: item.Value,
							value: item.Text
						}));
					}
				})
			},
			async Export() {
				const loading = this.$loading({
					lock: true,
					text: '正在导出...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let resexprot = await exportProductTraceability({
					InvUniqueCode: this.FromArr[0].modelvalue,
					Batch: this.FromArr[1].modelvalue,
					Inventory: this.FromArr[2].modelvalue,
					CompanyIDs: Array.isArray(this.FromArr[3].modelvalue) ? this.FromArr[3].modelvalue.join(',') : '',
					DPDate1: this.FromArr[4].StartTime || '',
					DPDate2: this.FromArr[4].EndTime || '',
					InvClass: Array.isArray(this.FromArr[5].modelvalue) ? this.FromArr[5].modelvalue.join(',') : '',
					pageSize: this.pageSize,
					pageIndex: this.pageIndex
				})
				loading.close()
				if (resexprot) {
					let date = new Date()
					let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
					utils.downloadFile(resexprot, `追溯结果${str}`, "xlsx")
				} else {
					// 返回json
					this.$message.warning('导出失败');
				}
			},
			// 列表
			async ProductTraceability() {
				// if (!this.FromArr[0].modelvalue) {
				// 	this.$message.warning("请填写搜索条件！");
				// 	return
				// }
				this.ProductLoadingTable = true
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				// this.ProductLoadingTable = true
				let {
					data,
					message,
					code
				} = await ProductTraceability({
					InvUniqueCode: this.FromArr[0].modelvalue,
					Batch: this.FromArr[1].modelvalue,
					Inventory: this.FromArr[2].modelvalue,
					CompanyIDs: Array.isArray(this.FromArr[3].modelvalue) ? this.FromArr[3].modelvalue.join(',') : '',
					DPDate1: this.FromArr[4].StartTime || '',
					DPDate2: this.FromArr[4].EndTime || '',
					InvClass: Array.isArray(this.FromArr[5].modelvalue) ? this.FromArr[5].modelvalue.join(',') : '',
					pageSize: this.pageSize,
					pageIndex: this.pageIndex
				})
				if (code == 0) {
					this.total = data.Count
					this.tableData = data.data.map(it => {
						it.ValiDate = it.ValiDate ? it.ValiDate.substring(0, 10) : '';
						it.Date = it.Date ? it.Date.substring(0, 10) : '';
						return it;
					})
				} else {
					this.$message.warning(message)
				}
				// this.ProductLoadingTable = false
				loading.close()
			},
			SelectClick() {
				this.pageIndex = 1
				this.ProductTraceability()
			},
			reset() {
				this['tableData'] = [];
				this['total'] = 0;
				this['pageIndex'] = 1;
				this['pageSize'] = 20;
				this.FromArr.forEach((item, index) => {
					if (item.inputtype === 'dateSection') {
						item.StartTime = '';
						item.EndTime = '';
					} else {
						item.modelvalue = item.multiple ? [] : ''
					}
				})
			},
			onRowClick(val) {
				this.rowData = val
			},
			handleCurrentChange(pageIndex) {
				this.pageIndex = pageIndex
				this.ProductTraceability()
			},
			handleSizeChange(pageSize) {
				this.pageSize = pageSize
				this.ProductTraceability()
			}
		}
	}
</script>

<style lang="less" scoped>
	.ProductTraceabilityBox {
		width: 100%;
		display: flex;
		justify-content: space-around;
		justify-items: center;

		.ProductTraceability {
			margin-top: 16px;
			margin-bottom: 100px;
			width: 1180px;
			min-height: 450px;
			background: #ffffff;
			border-radius: 4px 4px 4px 4px;
			opacity: 1;

			.FromComm {
				//width: 904px;
				//margin-left: 131px;
				margin-top: 48px;
				//display: flex;
				// outline: 1px solid red;
				//justify-content: space-between;

				/deep/ .el-select {
					margin-top: 6px;
				}
				/deep/ .el-select .el-input__inner,
				/deep/ .el-date-editor .el-input__inner {
					height: 48px !important;
					line-height: 48px !important;
					font-size: 14px;
				}
				/deep/ .el-select .el-input__icon,
				/deep/ .el-date-editor .el-input__icon {
					line-height: 48px !important;
					height: 48px !important;
				}
				/deep/ .el-input__suffix .el-input__suffix-inner .el-select__caret.el-input__icon.el-icon-arrow-up {
					top: 0 !important;
				}
				/deep/ .el-select .el-input .el-select__caret.is-reverse {
					transform: rotateZ(180deg) !important;
				}
				/deep/ .el-select .el-input__icon.el-icon-circle-close {
					top: 0 !important;
					right: 2px !important;
				}

				.btns {
					padding-right: 24px;
					display: flex;
					justify-content: flex-end;
					margin-top: 20px;

					button {
						width: 96px;
						height: 48px;
						margin-top: 18px;
						border-radius: 2px 2px 2px 2px;
						opacity: 1;
					}

					button:nth-child(1) {
						background-color: #ffffff;
						color: #666666;
					}

					button:nth-child(2) {
						background-color: #e71d43;
						color: #ffffff;
					}
				}
			}

			h1 {

				margin-top: 48px;
				margin-bottom: 24px;
				text-align: center;
			}
		}
	}
</style>